import React, { useEffect, useRef } from 'react';

interface FeatherIconProps {
  name: string;
  size?: number;
  className?: string;
  color?: string;
}

const FeatherIcon: React.FC<FeatherIconProps> = ({
  name,
  size = 24,
  className = '',
  color
}) => {
  const iconRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const loadFeatherIcons = async () => {
      try {
        // Use the installed feather-icons package
        const feather = await import('feather-icons');

        if (iconRef.current) {
          const iconHtml = (feather.icons as any)[name]?.toSvg({
            width: size,
            height: size,
            color: color
          });

          if (iconHtml) {
            iconRef.current.innerHTML = iconHtml;
          }
        }
      } catch (error) {
        console.error('Failed to load feather icon:', error);
        // Fallback to simple text representation
        if (iconRef.current) {
          iconRef.current.innerHTML = `<span>[${name}]</span>`;
        }
      }
    };

    loadFeatherIcons();
  }, [name, size, color]);

  return <i ref={iconRef} className={className} />;
};

export default FeatherIcon;